import React from 'react'
import StandardProductDashboard from './StandardProductDashboard'

/**
 * Entertainment — Sky's entertainment dashboard.
 *
 * Sky's biggest campaign by post volume. Its comments were absent from the saved widget until the 2026-08-11 widening, so its history starts shallower than its volume suggests.
 *
 * It is deliberately three lines. A department's dashboard is an ARRANGEMENT,
 * and today every department arranges the same way, so this file's only job is
 * to name the product and its copy. When Entertainment asks for something different,
 * this is the file that changes: drop StandardProductDashboard, compose the kit
 * primitives directly, and nothing else in the codebase moves.
 */
export const EntertainmentDashboard: React.FC = () => (
  <StandardProductDashboard
    product="entertainment"
    title="Entertainment"
    subtitle="Sky's entertainment output - shows, talent and channel promotion."
  />
)

export default EntertainmentDashboard
